"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

const STORAGE_KEY = "bitstone_cookie_consent";

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(localStorage.getItem(STORAGE_KEY) !== "accepted");
  }, []);

  function acceptCookies() {
    localStorage.setItem(STORAGE_KEY, "accepted");
    window.dispatchEvent(new Event("bitstone-cookie-consent"));
    setVisible(false);
  }

  if (!visible) {
    return null;
  }

  return (
    <div className="cookie-consent" role="dialog" aria-label="Согласие на cookies">
      <div>
        <strong>Cookies и аналитика</strong>
        <p>
          Мы используем технические cookies для работы корзины и региона, а аналитику
          включаем только после вашего согласия. Подробнее: <Link href="/cookies">политика cookies</Link>.
        </p>
      </div>
      <button className="primary-button" type="button" onClick={acceptCookies}>
        Принять
      </button>
    </div>
  );
}
